export interface OrganisationContactType {
    id: number;
    uid: string;
}
